import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import cargosServices from '../../services/cargosServices';
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import { errorClassification } from '../../errorHandler';

const ListaCargos = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [cargos, setCargos] = useState([]);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    obtenerCargos();
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin' || authInformation.rol === 'Veedor')){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const obtenerCargos = async () => {
    try {
      const data = await cargosServices.obtenerCargos();

      setCargos(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const eliminarCargo = async (cargo) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar a ${cargo.nombre}?`)){
        await cargosServices.eliminarCargo(cargo.id);

        const copiaCargos = [...cargos];
        setCargos(copiaCargos.filter((cargos) => cargos.id !== cargo.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const listarCargos = cargos && cargos.map((cargo, index) => {
    return (
      <tr key={index}>
        <td>{cargo.codigo}</td>
        <td>{cargo.nombre}</td>
        <td>{cargo.agrupamiento}</td>
        <td>
          {authInformation.rol === 'Admin' ? (
            <div className="btn-group" role="group">
              <Link className="btn btn-primary" to={`/cargo/${cargo.id}/edit`}>Editar</Link>{' '}
              <button className="btn btn-danger" onClick={()=>eliminarCargo(cargo)} >Eliminar</button>
            </div>
          ):('')}
        </td>
    </tr>
    )
  })

  return (
    <>
      <h1>Lista de cargos</h1>
      {
        (renderHTML) && (
          <>
          <div className="table-responsive small">
            <table className="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Categoría</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Agrupamiento</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {listarCargos}
              </tbody>
            </table>
          </div>
          </>
        )
      }
      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
      </>

  );
};

export default ListaCargos;